document.addEventListener("DOMContentLoaded", () => {
  const el = document.getElementById("color-cover");
  if (!el) return;

  const colors = JSON.parse(el.dataset.colors);
  const lastColor = localStorage.getItem("cover_color") ?? null;
  const available = lastColor ? colors.filter((c) => c !== lastColor) : colors;
  const pool = available.length > 0 ? available : colors;
  const color = pool[Math.floor(Math.random() * pool.length)];

  el.style.backgroundColor = color;
  localStorage.setItem("cover_color", color);
});
